var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* istanbul ignore file */
// all requires actual browser
import { Editor, Element as SlateElement, Transforms } from "slate";
import { LIST_TYPES, TEXT_ALIGN_TYPES } from "../constants";
import { ElementType } from "../types";
/**
 * check if block icon should be active
 */
export var isBlockActive = function (editor, format, blockType) {
    if (blockType === void 0) { blockType = "type"; }
    var selection = editor.selection;
    if (!selection)
        return false;
    // check if anything in the range of selection contains the block type
    var _a = __read(Array.from(Editor.nodes(editor, {
        at: Editor.unhangRange(editor, selection),
        match: function (n) {
            return !Editor.isEditor(n) &&
                SlateElement.isElement(n) &&
                n[blockType] === format;
        },
    })), 1), match = _a[0];
    return !!match;
};
/**
 * toggle a block selection
 */
export var toggleBlock = function (editor, format) {
    var isActive = isBlockActive(editor, format, TEXT_ALIGN_TYPES.includes(format) ? "align" : "type");
    var isList = LIST_TYPES.includes(format);
    // unwrap any nodes that are wrapped in this format type
    Transforms.unwrapNodes(editor, {
        match: function (n) {
            return !Editor.isEditor(n) &&
                SlateElement.isElement(n) &&
                LIST_TYPES.includes(n.type) &&
                !TEXT_ALIGN_TYPES.includes(format);
        },
        split: true,
    });
    var newProperties;
    // check if its an alignment or element change
    if (TEXT_ALIGN_TYPES.includes(format)) {
        newProperties = {
            align: isActive ? undefined : format,
        };
    }
    else {
        var type = isActive
            ? ElementType.Paragraph
            : isList
                ? ElementType.ListItem
                : format;
        newProperties = {
            type: type,
        };
    }
    Transforms.setNodes(editor, newProperties);
    // if node is unwrapped, wrap it
    if (!isActive && isList) {
        var block = { type: format, children: [] };
        Transforms.wrapNodes(editor, block);
    }
};
